export const APP_DATA = {
  appName: 'Clasol Suite Apps',
  companyName: 'CLASOL',
  version: '1.0.0',
}

export const APPLICATION_CODES = {
  suiteAdmin: 'SUITE_ADMIN',
  qualityProduction: 'QUALITY_PRODUCTION',
}

export const mockSession = {
  user: {
    id: 'local-quality-user',
    username: 'administrador',
    displayName: 'Administrador',
    active: true,
  },
  applications: [
    {
      application: {
        id: 'suite-admin',
        code: APPLICATION_CODES.suiteAdmin,
        name: 'Clasol Suite Admin',
      },
      permissions: ['*'],
    },
    {
      application: {
        id: 'quality-production',
        code: APPLICATION_CODES.qualityProduction,
        name: 'Calidad en produccion',
      },
      permissions: ['QUALITY_PRODUCTION_READ', 'QUALITY_PRODUCTION_WRITE'],
    },
  ],
}
